import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '');

export const PayMethodPicker = ({ value, onChange, accent }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginTop: '0.35rem' }}>
    {[['card', 'Assinatura mensal no cartão', 'Renova sozinha todo mês'], ['pix', 'Assinatura mensal no Pix', 'Pix do mês enviado por e-mail']].map(([id, label, hint]) => (
      <button key={id} type="button" onClick={() => onChange(id)} data-testid={`register-pay-${id}`} aria-pressed={value === id}
        style={{ textAlign: 'left', padding: '0.6rem 0.75rem', borderRadius: 8, cursor: 'pointer', border: `2px solid ${value === id ? accent : '#e2e8f0'}`,
          background: value === id ? '#f0fafa' : 'white', transition: 'border-color 0.15s ease' }}>
        <span style={{ display: 'block', fontWeight: 600, fontSize: '0.85rem', color: '#2D3748' }}>{label}</span>
        <span style={{ display: 'block', fontSize: '0.75rem', color: '#718096' }}>{hint}</span>
      </button>
    ))}
  </div>
);

export const AutoRenewNote = ({ platform, readerToken, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  if (platform.payment_method !== 'card' || platform.status !== 'active') return null;
  const cancel = async () => {
    if (!window.confirm('Cancelar a renovação automática? Seu acesso continua até o fim do período pago.')) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/reader/subscription/${platform.editor_id}/cancel`, {}, { headers: { Authorization: `Bearer ${readerToken}` } });
      setMsg(data.message);
      onChanged?.();
    } catch (e) {
      setMsg(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Não foi possível cancelar agora.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid={`auto-renew-${platform.editor_id}`} style={{ fontSize: '0.78rem', color: '#718096', margin: '-0.4rem 0.25rem 0.25rem', display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
      {msg || (platform.auto_renew
        ? <>Renova no cartão em {fmtDate(platform.subscription_end)} ·
            <button type="button" onClick={cancel} disabled={busy} data-testid={`cancel-renew-${platform.editor_id}`}
              style={{ background: 'none', border: 'none', padding: 0, color: '#c53030', cursor: 'pointer', textDecoration: 'underline', fontSize: 'inherit' }}>
              {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : 'cancelar renovação'}
            </button></>
        : <>Renovação automática cancelada · acesso até {fmtDate(platform.subscription_end)}</>)}
    </div>
  );
};
